import React, { useState } from "react";
import Orb from "./Orb";
import "./LoginRegister.css";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { auth, db, googleProvider, githubProvider } from "./firebaseClient";
import { createUserInDatabase, getUserProfile } from "./firestoreService";

const LoginRegister = ({ onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const saveUserProfile = async (
    userId,
    email,
    name = "",
    phone = "",
    college = ""
  ) => {
    try {
      const userData = await createUserInDatabase(
        userId,
        email,
        name,
        phone,
        college
      );
      return userData;
    } catch (error) {
      console.error("Error saving user profile:", error);
      throw error;
    }
  };

  const handleOAuthSignIn = async (provider) => {
    setIsSubmitting(true);
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const userProfile = await getUserProfile(user.uid);

      if (!userProfile) {
        await saveUserProfile(
          user.uid,
          user.email,
          user.displayName || "",
          "",
          ""
        );
      }

      alert("🎉 Sign in successful! Welcome to CRYPTERA 2K26!");
      onClose();
    } catch (error) {
      console.error("OAuth error:", error);
      alert("OAuth sign in failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="orb-background-login">
        <Orb
          hoverIntensity={0.3}
          rotateOnHover={true}
          hue={280}
          forceHoverState={false}
        />
      </div>

      <div className="login-card">
        <button className="close-btn-login" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>

        <div className="left">
          <h2>Welcome to CRYPTERA 2K26</h2>
          <p className="login-quote">
            "Innovation distinguishes between a leader and a follower."
          </p>
          <button
            type="button"
            className="btn google-signin-btn"
            onClick={() => handleOAuthSignIn(googleProvider)}
            disabled={isSubmitting}
          >
            <i className="fab fa-google"></i>
            {isSubmitting ? "Signing in..." : "Continue with Google"}
          </button>
        </div>

        <div className="right">
          <img
            src="/images/logo.png"
            alt="Cryptera Logo"
            className="login-logo"
          />
          <p>
            Join the ultimate technical symposium experience. Unravel the future
            of innovation with cutting-edge technology and brilliant minds.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginRegister;
